import { Component, Input, OnInit } from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import { ClientUser } from '@app/shared/models/client-user';
import { BaseList } from '@app/shared/models/list';
import { UserAssignment } from '@app/shared/models/user-assignment';


@Component({
    selector: 'user-client-settings',
    templateUrl: './user-client-settings.component.html'
})
export class UserClientSettingsComponent extends TwoWayBoundComponent<ClientUser>
                                         implements OnInit {

    @Input()
    public assignments: BaseList<UserAssignment>;

    get user() {
        return this.bananaBox;
    }

    constructor() {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();
    }

    public compareAssignments(ass1: UserAssignment, ass2: UserAssignment): boolean {
        return ass1 && ass2 ?
                ass1.client_id === ass2.client_id &&
                ass1.client_id2 === ass2.client_id2 &&
                ass1.office_id === ass2.office_id &&
                ass1.display_name === ass2.display_name :
                ass1 === ass2;
    }

}
